// import React, { useEffect, useState } from "react";
// import { ToastContainer, toast } from "react-toastify";
// import { BASE_URL, FRONTEND_URL, IMAGE_URL } from "../../config/axios";
// import usePermission from "../../config/permissions";
// import { Modal } from "react-bootstrap";
// import "react-toastify/dist/ReactToastify.css";
// import {
//   CustomImageModal,
//   handleAllError,
//   handleErrorToast,
// } from "../CustomFunctions";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";

// import { PieChart, Pie, Cell } from "recharts";
// import { Arrow, UpdatePencil } from "../AllSvg";
// import { padding } from "@mui/system";
// import UserDefaultLogo from "./UserDefaultLogo";
// import { useLocation } from "react-router-dom";

// const ProfileProgressChart = ({ percentage, color, imageUrl, name }) => {
//   const chartSize = 100;
//   const radius = chartSize / 2;

//   return (
//     <div className="progress-profile-chart" style={{ "--color": color }}>
//       <PieChart width={chartSize} height={chartSize}>
//         <Pie
//           data={[{ value: percentage }, { value: 100 - percentage }]}
//           innerRadius={radius - 10}
//           outerRadius={radius}
//           startAngle={90}
//           endAngle={-270}
//           cornerRadius={20}
//         >
//           <Cell fill={color} />
//           <Cell fill="#EFEFEF" />
//         </Pie>
//       </PieChart>

//       <CustomImageModal customStyle>
//         {imageUrl ? (
//           <img
//             src={`${IMAGE_URL}${imageUrl}`}
//             alt="Profile Pic"
//             className="width-5vw image-radius"
//           />
//         ) : (
//           <UserDefaultLogo
//             user={{ name: name, profilepic: "" }}
//             customStyleforParent={
//               "reqOutDuty-default-logo-dashboard profile-on-modal"
//             }
//             customStyleforChild={"small-profile-dashboard profile-small-modal"}
//           />
//         )}
//       </CustomImageModal>

//       {/* </a> */}
//       <div className="progress-profile-percent">{percentage?.toFixed(2)}%</div>
//     </div>
//   );
// };

// const ProfileProgressModal = () => {
//   const [buffer, setBuffering] = useState(true);
//   const [profile, setProfile] = useState(sessionStorage.getItem("profilepic"));
//   const [name, setName] = useState(sessionStorage.getItem("name"));
//   const [profileProgress, setProfileProgress] = useState();
//   const [bankProgress, setBankProgress] = useState();
//   const [hoveredItem, setHoveredItem] = useState(null);

//   // State to control the Bank Instructions Modal
//   const [showBankSteps, setShowBankSteps] = useState(false);

//   const { PORTAL_SETTINGS } = usePermission();
//   const navigate = useNavigate();
//   const location = useLocation();

//   const routes = [
//     {
//       name: "Personal Details",
//       progress: profileProgress?.personal_data?.completion_percentage,
//       route: `${FRONTEND_URL}/personalDetailss/${sessionStorage.getItem("email")}/`,
//     },
//     {
//       name: "Education Details",
//       progress: profileProgress?.education_details?.completion_percentage,
//       route: `${FRONTEND_URL}/educationDetailss/${sessionStorage.getItem("email")}/`,
//     },
//     {
//       name: "Work Experience",
//       progress: profileProgress?.work_experience_details?.completion_percentage,
//       route: `${FRONTEND_URL}/workexperiencee/${sessionStorage.getItem("email")}/`,
//     },
//     {
//       name: "Emergency Contacts",
//       progress:
//         profileProgress?.emergency_contact_details?.completion_percentage,
//       route: `${FRONTEND_URL}/emergencycontacts/${sessionStorage.getItem("email")}/`,
//     },
//     {
//       name: "Account Details",
//       progress: bankProgress?.completion_percentage,
//       route: `${FRONTEND_URL}/userdetail/`,
//     },
//     {
//       name: "Documents",
//       progress: profileProgress?.document_details?.completion_percentage,
//       route: `${FRONTEND_URL}/documentdetailss/${sessionStorage.getItem("email")}/`,
//     },
//   ];

//   const totalProgress = routes
//     .map((route) => route.progress)
//     .filter((progress) => progress !== undefined && progress !== null)
//     .reduce((acc, progress) => acc + progress, 0);

//   const numberOfValidEntries = routes.filter(
//     (route) => route.progress !== undefined && route.progress !== null,
//   ).length;

//   const overallCompletion =
//     numberOfValidEntries > 0 ? totalProgress / numberOfValidEntries : 0;

//   const fetchData = async () => {
//     setBuffering(true);
//     try {
//       const profileprogress = await axios.get(
//         `${BASE_URL}/userdata/newoldusercompletion/${sessionStorage.getItem("email")}/`,
//       );
//       setProfileProgress(profileprogress.data);

//       const bankprogress = await axios.get(
//         `${BASE_URL}/userdata/profilepercentageBank/${sessionStorage.getItem("emp_code")}/`,
//       );
//       setBankProgress(bankprogress.data);
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setBuffering(false);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const getProgressColor = (percentage) => {
//     if (percentage <= 33) return "#ff747c";
//     if (percentage <= 66) return "#f7ba1e";
//     if (percentage <= 100) return "#06ad06";
//     return "#2576bc";
//   };

//   return (
//     <>
//       <div
//         className={`navbar-logo-icon ${
//           overallCompletion >= 100 ? "" : "navbar-svg-profile"
//         }`}
//         style={{ position: "relative" }}
//       >
//         {overallCompletion >= 100 ? null : (
//           <span className="notification-count">!</span>
//         )}

//         <CustomImageModal customStyle>
//           {profile ? (
//             <img
//               src={`${IMAGE_URL}${profile}`}
//               alt="User Profile"
//               className="navbar-user-login"
//             />
//           ) : (
//             <UserDefaultLogo
//               user={{ name: name, profilepic: "" }}
//               customStyleforParent={"reqOutDuty-default-logo-dashboard"}
//               customStyleforChild={"navbar-user-login"}
//             />
//           )}
//         </CustomImageModal>

//         <div className="user-profile-progress custom-notify-modal">
//           <h1 className="task-Tab-heading align-center font-weight500 font-size-heading">
//             <Modal.Title>Profile Status</Modal.Title>
//           </h1>
//           <ProfileProgressChart
//             percentage={overallCompletion}
//             color={getProgressColor(overallCompletion)}
//             imageUrl={profile || ""}
//             name={name || ""}
//           />
//           {name && <div className="align-center">{name}</div>}

//           {routes.map((item, index) => (
//             <div className="progress-item" key={index}>
//               <div className="progress-info">
//                 <div className="progress-details">
//                   <span>{item.name}</span>
//                   <span style={{ marginLeft: "10px" }}>
//                     {item?.progress?.toFixed(2)}%
//                   </span>
//                 </div>
//                 <div className="progress-bar">
//                   <div
//                     className="progress-fill"
//                     style={{
//                       width: `${item.progress}%`,
//                       backgroundColor: getProgressColor(item.progress),
//                     }}
//                   />
//                 </div>
//               </div>

//               {PORTAL_SETTINGS?.emp_details_edit && (
//                 <a
//                   href={item.name === "Account Details" ? "#" : item.route}
//                   target={item.name === "Account Details" ? "_self" : "_blank"}
//                   rel="noopener noreferrer"
//                   title={
//                     item.name === "Account Details"
//                       ? "Steps to update/change bank details"
//                       : ""
//                   }
//                   onMouseEnter={() => setHoveredItem(index)}
//                   onMouseLeave={() => setHoveredItem(null)}
//                   className="progress-link"
//                   onClick={(e) => {
//                     if (item.name === "Account Details") {
//                       e.preventDefault();
//                       setShowBankSteps(true);
//                     }
//                   }}
//                 >
//                   {item.progress === 100 ? (
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       width="22"
//                       height="22"
//                       viewBox="0 0 20 20"
//                       style={{
//                         fill:
//                           hoveredItem === index
//                             ? "#fff"
//                             : getProgressColor(item.progress),
//                         backgroundColor:
//                           hoveredItem === index
//                             ? getProgressColor(item.progress)
//                             : "#fff",
//                         borderRadius: "30px",
//                       }}
//                     >
//                       <path
//                         fillRule="evenodd"
//                         d="M16.7724 5.21182C17.0696 5.5003 17.0767 5.97513 16.7882 6.27236L8.53819 14.7724C8.39571 14.9192 8.19945 15.0014 7.99489 15C7.79032 14.9986 7.5952 14.9137 7.45474 14.765L3.20474 10.265C2.92033 9.96383 2.9339 9.48915 3.23503 9.20474C3.53617 8.92033 4.01085 8.93389 4.29526 9.23503L8.0074 13.1655L15.7118 5.22764C16.0003 4.93041 16.4751 4.92333 16.7724 5.21182Z"
//                         clipRule="evenodd"
//                       ></path>
//                     </svg>
//                   ) : (
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       width="24"
//                       height="24"
//                       viewBox="0 0 48 48"
//                       style={{
//                         fill:
//                           hoveredItem === index
//                             ? "#fff"
//                             : getProgressColor(item.progress),
//                         backgroundColor:
//                           hoveredItem === index
//                             ? getProgressColor(item.progress)
//                             : "#fff",
//                         borderRadius: "30px",
//                       }}
//                     >
//                       <path fill="none" d="M0 0h48v48H0z" />
//                       <path d="m24 8-2.83 2.83L32.34 22H8v4h24.34L21.17 37.17 24 40l16-16z" />
//                     </svg>
//                   )}
//                 </a>
//               )}
//             </div>
//           ))}
//         </div>
//       </div>

//       <ToastContainer
//         position="top-center"
//         autoClose={1000}
//         hideProgressBar={false}
//         newestOnTop={true}
//         closeOnClick
//         rtl={false}
//         pauseOnFocusLoss
//         draggable
//         pauseOnHover
//       />

//       {/* --- SHORT DYNAMIC BANK INSTRUCTIONS MODAL --- */}
//       <Modal
//         show={showBankSteps}
//         onHide={() => setShowBankSteps(false)}
//         size="lg"
//         centered
//         dialogClassName="bank-steps-modal"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title style={{ color: "#2576bc", fontWeight: "600" }}>
//             How to Manage Bank Details
//           </Modal.Title>
//         </Modal.Header>

//         <Modal.Body style={{ padding: "30px", backgroundColor: "#fff" }}>
//           {/* Step 1: Visual Mockup */}
//           <div style={{ marginBottom: "30px" }}>
//             <h5 style={{ fontWeight: "600", color: "#334155" }}>
//               Step 1: Open Options Menu
//             </h5>
//             <p
//               style={{
//                 color: "#64748b",
//                 fontSize: "15px",
//                 marginBottom: "15px",
//               }}
//             >
//               Navigate to your profile page. On your profile card, click the
//               three vertical dots (⋮) in the top right corner and select{" "}
//               <strong>Bank Details</strong>.
//             </p>

//             {/* Full UI Mockup of the Profile Card */}
//             <div
//               style={{
//                 background: "#f8f9fb",
//                 borderRadius: "8px",
//                 border: "1px solid #e2e8f0",
//                 display: "flex",
//                 position: "relative",
//                 overflow: "visible", // Allowed visible for the dropdown
//                 fontFamily: "sans-serif",
//               }}
//             >
//               {/* Left Side - Image and Blue Bar */}
//               <div
//                 style={{
//                   width: "160px",
//                   display: "flex",
//                   flexDirection: "column",
//                 }}
//               >
//                 <div
//                   style={{
//                     height: "160px",
//                     backgroundColor: "#e2e8f0",
//                     display: "flex",
//                     justifyContent: "center",
//                     alignItems: "flex-end",
//                     overflow: "hidden",
//                     position: "relative",
//                   }}
//                 >
//                   {/* Mock Avatar */}
//                   <div
//                     style={{
//                       width: "90px",
//                       height: "100px",
//                       backgroundColor: "#cbd5e1",
//                       borderRadius: "45px 45px 0 0",
//                     }}
//                   ></div>
//                   <div
//                     style={{
//                       position: "absolute",
//                       top: "10px",
//                       right: "10px",
//                       color: "#2576bc",
//                       fontSize: "18px",
//                       fontWeight: "bold",
//                       lineHeight: "10px",
//                     }}
//                   >
//                     ⋮
//                   </div>
//                 </div>
//                 <div
//                   style={{
//                     backgroundColor: "#85a8d0",
//                     color: "white",
//                     textAlign: "center",
//                     padding: "8px",
//                     fontSize: "13px",
//                     fontWeight: "500",
//                     borderRadius: "0 0 0 8px",
//                   }}
//                 >
//                   Software Developer
//                 </div>
//               </div>

//               {/* Right Side - Details */}
//               <div
//                 style={{
//                   padding: "20px 25px",
//                   flex: 1,
//                   display: "flex",
//                   flexDirection: "column",
//                   justifyContent: "center",
//                   gap: "8px",
//                 }}
//               >
//                 <h3
//                   style={{
//                     color: "#2576bc",
//                     margin: 0,
//                     fontWeight: "600",
//                     fontSize: "22px",
//                   }}
//                 >
//                   John Doe
//                 </h3>
//                 <p
//                   style={{
//                     color: "#1e293b",
//                     margin: "0 0 8px 0",
//                     fontSize: "15px",
//                     fontWeight: "500",
//                   }}
//                 >
//                   Software Developer at Aimantra
//                 </p>

//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "8px",
//                     color: "#64748b",
//                     fontSize: "14px",
//                   }}
//                 >
//                   <span style={{ fontSize: "16px" }}>📍</span> Civil Mantra :
//                   Tower 3A-3rd Floor, Corporate Greens, Gurugram
//                 </div>
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "8px",
//                     color: "#2576bc",
//                     fontSize: "14px",
//                   }}
//                 >
//                   <span style={{ color: "#64748b", fontSize: "16px" }}>✉️</span>{" "}
//                   john.doe@gmail.com
//                 </div>
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "8px",
//                     color: "#2576bc",
//                     fontSize: "14px",
//                   }}
//                 >
//                   <span style={{ color: "#64748b", fontSize: "16px" }}>📞</span>{" "}
//                   9876543210
//                 </div>
//               </div>

//               {/* Top Right 3 Dots & Dropdown */}
//               <div style={{ position: "absolute", top: "15px", right: "20px" }}>
//                 <div
//                   style={{
//                     color: "#2576bc",
//                     fontWeight: "bold",
//                     fontSize: "22px",
//                     lineHeight: "10px",
//                     cursor: "pointer",
//                     textAlign: "right",
//                   }}
//                 >
//                   ⋮
//                 </div>

//                 {/* Mock Dropdown Menu */}
//                 <div
//                   style={{
//                     position: "absolute",
//                     top: "25px",
//                     right: "0",
//                     border: "1px solid #cbd5e1",
//                     borderRadius: "8px",
//                     background: "#fff",
//                     boxShadow: "0 8px 20px rgba(0, 0, 0, 0.15)", // Stronger shadow for depth
//                     width: "190px",
//                     zIndex: 10,
//                     overflow: "hidden", // Keeps highlight inside the rounded corners
//                   }}
//                 >
//                   <div
//                     style={{
//                       padding: "12px 15px",
//                       borderBottom: "1px solid #f1f5f9",
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "10px",
//                       color: "#64748b",
//                       fontSize: "14px",
//                       background: "#fff",
//                     }}
//                   >
//                     <span>✏️</span> Edit Profile Details
//                   </div>
//                   {/* Highlighted Bank Details Button */}
//                   <div
//                     style={{
//                       padding: "12px 15px",
//                       background: "#d4ebff", // Subtle greyish highlight
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "10px",
//                       color: "#0f172a", // Darker text for emphasis
//                       fontSize: "14px",
//                       fontWeight: "600",
//                     }}
//                   >
//                     <span>💳</span> Bank Details
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <hr style={{ borderColor: "#e2e8f0", margin: "25px 0" }} />

//           {/* Step 2: Dynamic Instructions */}
//           <h5
//             style={{
//               fontWeight: "600",
//               color: "#334155",
//               marginBottom: "15px",
//             }}
//           >
//             Step 2: Submit Your Details
//           </h5>

//           <div
//             style={{
//               background: "#eff6ff",
//               border: "1px solid #bfdbfe",
//               padding: "18px",
//               borderRadius: "8px",
//             }}
//           >
//             {/* Point (a): Adding for the first time */}
//             <div style={{ marginBottom: "15px" }}>
//               <strong style={{ color: "#1e3a8a", fontSize: "15px" }}>
//                 (a) If adding bank details for the first time:
//               </strong>
//               <p
//                 style={{
//                   margin: "5px 0 0",
//                   color: "#1e3a8a",
//                   fontSize: "14.5px",
//                   lineHeight: "1.6",
//                 }}
//               >
//                 You will automatically see an{" "}
//                 <strong>"Add Bank Details"</strong> form. Fill in your Account
//                 Number, IFSC, Bank Name, Branch, and attach a valid proof
//                 (Canceled Cheque or Bank Statement) to complete your profile.
//               </p>
//             </div>

//             <hr style={{ borderColor: "#bfdbfe", margin: "15px 0" }} />

//             {/* Point (b): Updating existing details */}
//             <div>
//               <strong style={{ color: "#1e3a8a", fontSize: "15px" }}>
//                 (b) To update your existing details:
//               </strong>
//               <p
//                 style={{
//                   margin: "5px 0 0",
//                   color: "#1e3a8a",
//                   fontSize: "14.5px",
//                   lineHeight: "1.6",
//                 }}
//               >
//                 1. Look for the <strong>"Request Changes"</strong> toggle switch
//                 in the top right of the popup.
//                 <br />
//                 2. Turn it ON to unlock the form.
//                 <br />
//                 3. Enter your new details, provide a reason, attach your proof,
//                 and submit for approval.
//                 <br />
//                 <br />
//                 <span style={{ color: "#9a3412" }}>
//                   <em>
//                     Note: If you already have a pending request, you must wait
//                     for it to be approved or rejected before making new changes.
//                   </em>
//                 </span>
//               </p>
//             </div>
//           </div>

//           <div className="button-models">
//             <button
//               className="model-button-cancel model-button font-weight500"
//               onClick={() => setShowBankSteps(false)}
//             >
//               Close
//             </button>
//           </div>
//         </Modal.Body>
//       </Modal>
//     </>
//   );
// };

// export { ProfileProgressModal };



import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { BASE_URL, FRONTEND_URL, IMAGE_URL } from '../../config/axios';
import usePermission from '../../config/permissions';
import { Modal } from 'react-bootstrap';
import 'react-toastify/dist/ReactToastify.css';
import { CustomImageModal, handleAllError, handleErrorToast } from '../CustomFunctions';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

import { PieChart, Pie, Cell } from 'recharts';
import { Arrow, UpdatePencil } from '../AllSvg';
import { padding } from '@mui/system';
import UserDefaultLogo from './UserDefaultLogo';
import { useLocation } from 'react-router-dom';

const ProfileProgressChart = ({ percentage, color, imageUrl, name }) => {

  const chartSize = 100;
  const radius = chartSize / 2;

  return (
    <div className="progress-profile-chart" style={{ "--color": color }}>
      <PieChart width={chartSize} height={chartSize}>
        <Pie
          data={[{ value: percentage }, { value: 100 - percentage }]}
          innerRadius={radius - 10}
          outerRadius={radius}
          startAngle={90}
          endAngle={-270}
          cornerRadius={20}
        >
          <Cell fill={color} />
          <Cell fill="#EFEFEF" />
        </Pie>
      </PieChart>

      <CustomImageModal customStyle>
        {imageUrl ? (
          <img
            src={`${IMAGE_URL}${imageUrl}`}
            alt="Profile Pic"
            /*  Removed 'width-5vw' to let the CSS handle the 70% circular sizing */
            className='image-radius'
          />
        ) : (
          <UserDefaultLogo
            user={{ name: name, profilepic: '' }}
            customStyleforParent={"reqOutDuty-default-logo-dashboard profile-on-modal"}
            customStyleforChild={'small-profile-dashboard profile-small-modal'}
          />
        )}
      </CustomImageModal>

      <div className="progress-profile-percent">
        {percentage?.toFixed(2)}%
      </div>
    </div>
  );
};


const ProfileProgressModal = () => {

  const [buffer, setBuffering] = useState(true); //buffering logic
  const [progress, setProgress] = useState();
  const [profile, setProfile] = useState(sessionStorage.getItem("profilepic"));
  const [name, setName] = useState(sessionStorage.getItem("name"));
  const [profileProgress, setProfileProgress] = useState();
  const [bankProgress, setBankProgress] = useState();
  const [hoveredItem, setHoveredItem] = useState(null);  // For tracking hover state

  const [showBankSteps, setShowBankSteps] = useState(false);

  const { PORTAL_SETTINGS } = usePermission();

  const navigate = useNavigate();
  const location = useLocation();

  const handleAccountDetailsClick = () => {
    const currentUrl = window.location.href;
    const urlParts = currentUrl.split('/');
    const url = urlParts[3];
    navigate(`/${url}/userdetail/`);
  };


  const routes = [
    { name: 'Personal Details', progress: profileProgress?.personal_data?.completion_percentage, route: `${FRONTEND_URL}/personalDetailss/${sessionStorage.getItem('email')}/?company_id=${sessionStorage.getItem("company_id") || "null"}` },
    { name: 'Education Details', progress: profileProgress?.education_details?.completion_percentage, route: `${FRONTEND_URL}/educationDetailss/${sessionStorage.getItem('email')}/?company_id=${sessionStorage.getItem("company_id") || "null"}` },
    { name: 'Work Experience', progress: profileProgress?.work_experience_details?.completion_percentage, route: `${FRONTEND_URL}/workexperiencee/${sessionStorage.getItem('email')}/?company_id=${sessionStorage.getItem("company_id") || "null"}` },
    { name: 'Emergency Contacts', progress: profileProgress?.emergency_contact_details?.completion_percentage, route: `${FRONTEND_URL}/emergencycontacts/${sessionStorage.getItem('email')}/?company_id=${sessionStorage.getItem("company_id") || "null"}` },
    { name: 'Account Details', progress: bankProgress?.completion_percentage, route: `${FRONTEND_URL}/userdetail/?company_id=${sessionStorage.getItem("company_id") || "null"}` },
    { name: 'Documents', progress: profileProgress?.document_details?.completion_percentage, route: `${FRONTEND_URL}/documentdetailss/${sessionStorage.getItem('email')}/?company_id=${sessionStorage.getItem("company_id") || "null"}` },
  ];


  // let totalprogress = 90
  const totalProgress = routes
    .map(route => route.progress) // Get all progress values
    .filter(progress => progress !== undefined && progress !== null) // Filter out undefined or null progress
    .reduce((acc, progress) => acc + progress, 0); // Sum the remaining values

  const numberOfValidEntries = routes.filter(route => route.progress !== undefined && route.progress !== null).length;

  const overallCompletion = (numberOfValidEntries > 0) ? (totalProgress / numberOfValidEntries) : 0;

  const fetchData = async () => {
    setBuffering(true); // Start Buffering
    try {
      // setProfileProgress([]);
      const profileprogress = await axios.get(`${BASE_URL}/userdata/newoldusercompletion/${sessionStorage.getItem('email')}/`);
      setProfileProgress(profileprogress.data);
      // setBankProgress([]);
      const bankprogress = await axios.get(`${BASE_URL}/userdata/profilepercentageBank/${sessionStorage.getItem('emp_code')}/`);
      setBankProgress(bankprogress.data);


    } catch (err) {
      // handleAllError(err)
    } finally {
      setBuffering(false);// End Buffering
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const handleProfilePicUpdate = (event) => {
      setProfile(event.detail || null);
    };

    window.addEventListener('profilepic-updated', handleProfilePicUpdate);
    return () => window.removeEventListener('profilepic-updated', handleProfilePicUpdate);
  }, []);

  // console.log(bankProgress, "bankhprogress");


  // const getProgressColor = (percentage) => {
  //   // if (percentage < 10) return '#ff747c';
  //   if (percentage < 33) return '#ff747c';
  //   if (percentage < 66) return '#f7ba1e';
  //   return '#06ad06';
  // };

  const getProgressColor = (percentage) => {
    // if (percentage < 10) return '#ff747c';
    if (percentage <= 33) return '#ff747c';
    if (percentage <= 66) return '#f7ba1e';
    if (percentage <= 100) return '#06ad06';
    return '#2576bc';
  };

  console.log(location.pathname, "path");

  return (
    <>
      <div className={`navbar-logo-icon ${overallCompletion >= 100 ? '' : 'navbar-svg-profile'}`} style={{ position: 'relative' }}>
        {
          overallCompletion >= 100 ? null : <span className="notification-count">!</span>}

        <CustomImageModal customStyle>
          {profile ? (
            <img
              src={`${IMAGE_URL}${profile}`}
              alt="User Profile" className='navbar-user-login'
            />
          ) : (
            <UserDefaultLogo user={{ name: name, profilepic: '' }} customStyleforParent={"default-profile-logo"} customStyleforChild={'navbar-user-login'} />
          )}
        </CustomImageModal>

        <div className="user-profile-progress custom-notify-modal">
          {/* Profile Details Completion status */}
          <h1 className="task-Tab-heading align-center font-weight500 font-size-heading">
            <Modal.Title>Profile Status</Modal.Title>
          </h1>
          <ProfileProgressChart
            percentage={overallCompletion}
            color={getProgressColor(overallCompletion)}
            imageUrl={profile || ''}
            name={name || ''}
          />
          {name && <div className='align-center'>
            {name}
          </div>}
          {routes.map((item, index) => (
            <div className='progress-item' key={index} >
              <div className="progress-info">
                <div className='progress-details'>
                  <span>{item.name}</span>
                  <span style={{ marginLeft: '10px' }}>{item?.progress?.toFixed(2)}%</span>
                </div>
                <div className="progress-bar">
                  <div
                    className="progress-fill"
                    style={{
                      width: `${item.progress}%`,
                      backgroundColor: getProgressColor(item.progress),
                    }} />
                </div>
              </div>
              {PORTAL_SETTINGS?.emp_details_edit &&
                <a
                  href={
                    item.name === 'Account Details' ?
                      'https://cipl-aimantra.s3.amazonaws.com/employee_profilepics/Aimantra_2025-12-17_01-14-26_BD6VVnS_Step_1.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAQHXVOR4QX3WIULXG%2F20251216%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20251216T194428Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Signature=2d7386419eee0b63f6c8f67084a7f30b10eecafcd3463286d04ba6884508baf0'
                      : item.route}
                  target="_blank"
                  rel="noopener noreferrer"
                  title={item.name === 'Account Details' ? 'Steps to update/change bank details' : ''}
                  onMouseEnter={() => setHoveredItem(index)}
                  onMouseLeave={() => setHoveredItem(null)}
                  className="progress-link"
                  onClick={(e) => {
                    if (item.name === "Account Details") {
                      e.preventDefault();
                      setShowBankSteps(true);
                    }
                  }}
                >
                  {item.progress === 100 ?
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="22"
                      viewBox="0 0 20 20"
                      id="tick"
                      style={{
                        fill: hoveredItem === index ? '#fff' : getProgressColor(item.progress),
                        backgroundColor: hoveredItem === index ? getProgressColor(item.progress) : '#fff',
                        borderRadius: '30px',
                      }}>
                      <path fill={hoveredItem === index ? '#fff' : getProgressColor(item.progress)} fill-rule="evenodd" d="M16.7724 5.21182C17.0696 5.5003 17.0767 5.97513 16.7882 6.27236L8.53819 14.7724C8.39571 14.9192 8.19945 15.0014 7.99489 15C7.79032 14.9986 7.5952 14.9137 7.45474 14.765L3.20474 10.265C2.92033 9.96383 2.9339 9.48915 3.23503 9.20474C3.53617 8.92033 4.01085 8.93389 4.29526 9.23503L8.0074 13.1655L15.7118 5.22764C16.0003 4.93041 16.4751 4.92333 16.7724 5.21182Z" clip-rule="evenodd"></path>
                    </svg> :
                    < svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 48 48"
                      id="arrow"
                      style={{
                        fill: hoveredItem === index ? '#fff' : getProgressColor(item.progress),
                        backgroundColor: hoveredItem === index ? getProgressColor(item.progress) : '#fff',
                        borderRadius: '30px',
                      }}
                    >
                      <path fill="none" d="M0 0h48v48H0z" />
                      <path d="m24 8-2.83 2.83L32.34 22H8v4h24.34L21.17 37.17 24 40l16-16z" />
                    </svg>
                  }
                </a>
              }
            </div>
          ))}

        </div>
      </div >
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      {/* --- SHORT DYNAMIC BANK INSTRUCTIONS MODAL --- */}
      <Modal
        show={showBankSteps}
        onHide={() => setShowBankSteps(false)}
        size="lg"
        centered
        dialogClassName="bank-steps-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "#2576bc", fontWeight: "600" }}>
            How to Manage Bank Details
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: "30px", backgroundColor: "#fff" }}>
          {/* Step 1: Visual Mockup */}
          <div style={{ marginBottom: "30px" }}>
            <h5 style={{ fontWeight: "600", color: "#334155" }}>
              Step 1: Open Options Menu
            </h5>
            <p
              style={{
                color: "#64748b",
                fontSize: "15px",
                marginBottom: "15px",
              }}
            >
              Navigate to your profile page. On your profile card, click the
              three vertical dots (⋮) in the top right corner and select{" "}
              <strong>Bank Details</strong>.
            </p>

            {/* Full UI Mockup of the Profile Card */}
            <div
              className="profile-banner-wrapper"
              style={{
                pointerEvents: "none",
                position: "relative",
                overflow: "visible",
                margin: 0,
                padding: "16px",           /* Reduced padding to fit modal */
                gap: "15px"                /* Tighter gap between main sections */
              }}
            >
              <div className="profile-banner-main-info" style={{ gap: "12px", minWidth: 0 }}>

                {/* LEFT: Profile Picture & Status */}
                <div className="profile-banner-left">
                  <div className="profile-banner-img" style={{ width: "80px", height: "80px", display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#e2e8f0' }}>
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="#a0aec0">
                      <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                    </svg>
                  </div>
                  <div className="profile-banner-status-dot" style={{ backgroundColor: "#22C55E", width: "12px", height: "12px", border: "2px solid #fff", right: "0" }}></div>
                </div>

                {/* MIDDLE: Details */}
                <div className="profile-banner-middle" style={{
                  gap: "4px",
                  minWidth: 0,
                  flex: 1, /* Ensures this section takes available space without forcing overflow */
                  display: "flex",
                  flexDirection: "column"
                }}>
                  <div className="profile-banner-name-row" style={{ marginBottom: "2px" }}>
                    <h1 className="profile-banner-name" style={{ fontSize: "18px", margin: 0 }}>John Doe</h1>
                    <span className="profile-banner-active-badge" style={{ backgroundColor: 'rgba(255, 255, 255, 0.2)', color: '#fff', fontSize: "10px", padding: "2px 8px" }}>
                      Active
                    </span>
                  </div>

                  {/* Flex wrap ensures subtitle elements stack instead of overflow */}
                  <div
                    className="profile-banner-subtitle"
                    style={{
                      fontSize: "12px",
                      marginBottom: "4px",
                      display: "flex",
                      flexWrap: "wrap",
                      alignItems: "center",
                      gap: "4px 6px"
                    }}
                  >
                    <span>Asst. Full Stack Developer</span>
                    <span style={{ color: "rgba(255,255,255,0.5)", fontSize: "10px" }}>&bull;</span>
                    <span>Information Technology</span>
                  </div>

                  {/* Address and Email use flex-wrap to handle long lines */}
                  <div className="profile-banner-contact-row" style={{
                    fontSize: "11px",
                    gap: "6px",
                    display: "flex",
                    // flexWrap: "wrap" /* Allows address to wrap to next line */
                  }}>
                    <svg className="profile-banner-icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                    <span style={{ wordBreak: "break-word" }}>
                      Civil Mantra : Tower 3A-3rd Floor, Corporate Greens, Gurugram
                    </span>
                  </div>

                  <div className="profile-banner-contact-row" style={{ fontSize: "11px", gap: "6px", display: "flex" }}>
                    <svg className="profile-banner-icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
                    <span>johndoe@gmail.com</span>
                  </div>
                </div>
              </div>

              {/* RIGHT: Action Buttons & Stats Grid */}
              <div className="profile-banner-right" style={{ gap: "12px", flexShrink: 0 }}>

                <div className="profile-banner-actions" style={{ gap: "6px" }}>

                  <div className="profile-banner-btn" style={{ display: 'flex', alignItems: 'center', height: '32px', padding: "0 10px", fontSize: "12px" }}>
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 20h9"></path><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path></svg>
                    <span className="btn-label-text" style={{ marginLeft: "4px" }}>Edit Profile</span>
                  </div>

                  <div className="profile-banner-btn" style={{ display: 'flex', alignItems: 'center', height: '32px', padding: "0 10px", fontSize: "12px" }}>
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path><circle cx="12" cy="13" r="4"></circle></svg>
                    <span className="btn-label-text" style={{ marginLeft: "4px" }}>Change Photo</span>
                  </div>

                  <div style={{ position: 'relative' }}>
                    <div className="profile-banner-btn" style={{ display: 'flex', alignItems: 'center', height: '32px', padding: "0 10px", fontSize: "12px", boxShadow: '0 0 0 2px red' }}>
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="1"></circle><circle cx="12" cy="5" r="1"></circle><circle cx="12" cy="19" r="1"></circle></svg>
                      <span className="btn-label-text" style={{ marginLeft: "4px", marginRight: "4px" }}>More</span>
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="6 9 12 15 18 9"></polyline></svg>
                    </div>

                    {/* Dropdown Box */}
                    <div className="profile-banner-dropdown right-aligned" style={{ display: 'block', position: 'absolute', top: 'calc(100% + 4px)', right: '0', zIndex: 10, padding: '4px', background: '#fff', borderRadius: '6px', boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)', minWidth: '135px' }}>
                      <div style={{ padding: "6px 10px", display: "flex", alignItems: "center", gap: "8px", color: "#0f172a", fontSize: "12px", fontWeight: "600", background: '#f8fafc', borderRadius: '4px', border: '1px solid #e2e8f0' }}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#2576bc" strokeWidth="2"><rect x="2" y="5" width="20" height="14" rx="2"></rect><line x1="2" y1="10" x2="22" y2="10"></line></svg>
                        Bank Details
                      </div>
                    </div>
                  </div>
                </div>

                <div className="profile-banner-stats-grid" style={{ gap: "8px 16px" }}>
                  <div className="pb-stat-group">
                    <span className="pb-stat-label" style={{ fontSize: "10px" }}>Employee ID</span>
                    <span className="pb-stat-value" style={{ fontSize: "12px" }}>CIPL1170</span>
                  </div>
                  <div className="pb-stat-group">
                    <span className="pb-stat-label" style={{ fontSize: "10px" }}>Joining Date</span>
                    <span className="pb-stat-value" style={{ fontSize: "12px" }}>Jan 1, 2025</span>
                  </div>
                  <div className="pb-stat-group">
                    <span className="pb-stat-label" style={{ fontSize: "10px" }}>Department</span>
                    <span className="pb-stat-value" style={{ fontSize: "12px" }}>IT</span>
                  </div>
                  <div className="pb-stat-group">
                    <span className="pb-stat-label" style={{ fontSize: "10px" }}>Reporting To</span>
                    <span className="pb-stat-value" style={{ fontSize: "12px" }}>Mohit beniwal</span>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <hr style={{ borderColor: "#e2e8f0", margin: "25px 0" }} />

          {/* Step 2: Dynamic Instructions */}
          <h5
            style={{
              fontWeight: "600",
              color: "#334155",
              marginBottom: "15px",
            }}
          >
            Step 2: Submit Your Details
          </h5>

          <div
            style={{
              background: "#eff6ff",
              border: "1px solid #bfdbfe",
              padding: "18px",
              borderRadius: "8px",
            }}
          >
            {/* Point (a): Adding for the first time */}
            <div style={{ marginBottom: "15px" }}>
              <strong style={{ color: "#1e3a8a", fontSize: "15px" }}>
                (a) If adding bank details for the first time:
              </strong>
              <p
                style={{
                  margin: "5px 0 0",
                  color: "#1e3a8a",
                  fontSize: "14.5px",
                  lineHeight: "1.6",
                }}
              >
                You will automatically see an{" "}
                <strong>"Add Bank Details"</strong> form. Fill in your Account
                Number, IFSC, Bank Name, Branch, and attach a valid proof
                (Canceled Cheque or Bank Statement) to complete your profile.
              </p>
            </div>

            <hr style={{ borderColor: "#bfdbfe", margin: "15px 0" }} />

            {/* Point (b): Updating existing details */}
            <div>
              <strong style={{ color: "#1e3a8a", fontSize: "15px" }}>
                (b) To update your existing details:
              </strong>
              <p
                style={{
                  margin: "5px 0 0",
                  color: "#1e3a8a",
                  fontSize: "14.5px",
                  lineHeight: "1.6",
                }}
              >
                1. Look for the <strong>"Request Changes"</strong> toggle switch
                in the top right of the popup.
                <br />
                2. Turn it ON to unlock the form.
                <br />
                3. Enter your new details, provide a reason, attach your proof,
                and submit for approval.
                <br />
                <br />
                <span style={{ color: "#9a3412" }}>
                  <em>
                    Note: If you already have a pending request, you must wait
                    for it to be approved or rejected before making new changes.
                  </em>
                </span>
              </p>
            </div>
          </div>

          <div className="button-models">
            <button
              className="model-button-cancel model-button font-weight500"
              onClick={() => setShowBankSteps(false)}
            >
              Close
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export { ProfileProgressModal };